<div class="snapshot-attachment">
  <span class="snapshot-icon">
    <span [class]="platformThumbnail" class="snapshot-platform-thumbnail"></span>
  </span>
  <div class="snapshot-details">
    <div class="snapshot-util">
      <div class="snapshot-device-name" sa-ellipsis [fullText]="snapshot.details.deviceName"></div>
    </div>
    <div class="snapshot-util">
      <div class="snapshot-instance">{{ getConnectionName() }}</div>
      <div class="snapshot-date" *ngIf="snapshot?.details?.snapshotDate">
        ,
        {{ snapshot.details.snapshotDate | date : 'MMM d, y h:mm a' }}
      </div>
      <div class="snapshot-oval" *ngIf="!isSPPMode"></div>
      <div class="snapshot-link-button" *ngIf="!isSPPMode">
        <a (click)="previewSavedSnapshot()" class="btn btn-link btn-sm">
          <span class="subtext strong snapshot-link-button-text">{{ 'attachment_Preview_Caption' | xsI18n }}</span>
        </a>
      </div>
    </div>
  </div>
</div>

<div class="snapshot-body" [ngClass]="this.activityCtrl?.activityState">
  <textarea
    cdkTextareaAutosize
    id="description"
    name="note"
    [(ngModel)]="noteText"
    ngModelOptions="{ updateOn: 'default blur', debounce: { default: 250, blur: 0 } }"
    ngTrim="false"
    class="well-textarea"
    placeholder="{{ 'ticket_EnterDescription_Message' | xsI18n }}"
    (focus)="setEditing(true)"
    (blur)="setEditing(false)"
  >
  </textarea>
</div>

<div class="snapshot-footer" *ngIf="hasChanged">
  <!-- Buttons -->
  <div class="snapshot-footer-buttons">
    <button class="xs-btn btn-outline btn-space" (click)="cancel()">
      <span>{{ 'xs_cancel_label_short' | xsI18n }}</span>
    </button>

    <button class="xs-btn btn-primary" (click)="save()">
      <span>{{ 'activity_Update_Caption' | xsI18n }}</span>
    </button>
  </div>
</div>
